<p>{{ 'adddeliveryvehicle works!' | transloco }}</p>
